import { render, staticRenderFns } from "./WidgetAlerta.vue?vue&type=template&id=e15169f2&"
import script from "./WidgetAlerta.vue?vue&type=script&lang=ts&"
export * from "./WidgetAlerta.vue?vue&type=script&lang=ts&"
import style0 from "./WidgetAlerta.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports